import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCostLandingPage from 'lumen/components/settings/cost/landing-page';
import type MarketSettingsCostIndexController from 'lumen/controllers/market/settings/cost/index';
import type MarketSettingsCostIndexRoute from 'lumen/routes/market/settings/cost/index';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSettingsCostIndexSignature {
  Args: {
    controller: MarketSettingsCostIndexController;
    model: ModelFrom<MarketSettingsCostIndexRoute>;
  };
}

const MarketSettingsCostIndex: TOC<MarketSettingsCostIndexSignature> =
  <template>
    {{#if @model.profiles.isRunning}}
      <PrismLoadingBar />
    {{/if}}

    <SettingsCostLandingPage
      @isError={{@model.profiles.last.isError}}
      @isLoading={{@model.profiles.isRunning}}
      @isReadOnly={{@controller.isReadOnly}}
      @onProfileDeleted={{@controller.refreshProfiles}}
      @profiles={{or @model.profiles.last.value (array)}}
    />
  </template>;

export default MarketSettingsCostIndex;
